import {
  OwlCarousel,
  useRouter,
  Container,
  CustomContainer,
  Link,
} from "../../atoms/DependencyHelper";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import styles from "./SmallCardsCarousel.module.scss";
import {
  goToUrl,
  componentCheckSize,
  componentResize,
  createMarkup,
  internalUrl,
} from "../../../utils/helperServices";
import { useState } from "react";
import * as Analytics from "../../../services/analyticsUtag";

const SmallCardsCarousel = props => {
  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");
  const isMobile = componentCheckSize() <= 768;
  const sizeCheck = componentResize();
  const data = props.data.cards;
  let cardCarousel;
  const next = () => {
    if (cardCarousel) {
      cardCarousel.next(600);
    }
  };
  const prev = () => {
    if (cardCarousel) {
      cardCarousel.prev(600);
    }
  };
  const carouselOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: true,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots",
    dotClass: "owl--dot--small",
    margin: isMobile ? 8 : 16,
    responsive: {
      0: {
        dots: true,
        slideBy: 1,
        mouseDrag: true,
        touchDrag: true,
      },
      768: {
        dots: true,
        slideBy: 3,
      },
      1024: {
        dots: false,
      },
      1200: {
        slideBy: 2,
      },
      1440: {
        slideBy: 3,
      },
    },
  };
  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslate: function (event) {
      setCarouselLeftMargin(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
    },
  };

  function setCarouselLeftMargin(event) {
    const index = event.item.index;
    const maximum = event.item.count;

    let leftShift = "0px";
    if (!isMobile) {
      leftShift =
        index +
          carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >=
        maximum
          ? "23px"
          : "0px";
    }

    event.target.style.paddingLeft = leftShift;
  }

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    const minimum = 0;
    const maximum = event.item.count;

    let previousNav = index <= minimum ? "disabled" : "";
    let nextNav =
      index +
        carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >=
      maximum
        ? "disabled"
        : "";

    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  const router = useRouter();
  const handleClick = (item, index) => {
    // let url = item?.url || item?.link;
    // if (url.includes("internal:")) {
    //   url = url.split("internal:")[1];
    // }
    // goToUrl(url, router);
    Analytics.link({
      ...props.analyticsData,
      link_name: `${props.analyticsData?.page_name}: small: p${index + 1}: ${
        props?.data?.componentTitle
      }: ${props?.data?.cardType}: ${item.name}`,
    });
  };

  const generateAlignment = () => {
    switch (props?.data.heading_position) {
      case "left":
      case "LEFT": {
        return props?.data.heading_position
          ? "justify-content-start text-left"
          : "";
      }
      case "right":
      case "RIGHT": {
        return props?.data.heading_position
          ? "justify-content-end text-right"
          : "";
      }
      case "center":
      case "CENTER": {
        return props?.data.heading_position ? "text-center" : "";
      }
      default:
        return "text-left";
    }
  };

  return (
    <CustomContainer
      id={`${props.data.id}-smallCards`}
      className={`${styles["small-cards-carousel-container"]} small-card `}
    >
      <Container>
        <h4
          id={`${props.data.id}-smallCards-head`}
          className={`${
            styles[props.smallTitle ? "small-title" : "smallcards-title"]
          } ${generateAlignment()}`}
        >
          {props.data?.componentTitle || props.data?.title}
        </h4>
      </Container>

      <CustomContainer
        className={isMobile ? "container-fluid p-0" : "container"}
      >
        <CustomContainer className="owl-carousel-wrapper__small home-carousel  ">
          <OwlCarousel
            ref={c => (cardCarousel = c)}
            options={carouselOptions}
            events={events}
          >
            {data.map((item, index) => (
              <Link legacyBehavior
                key={`carousel-link-${index}`}
                href={internalUrl(item.url || item.link).url}
                prefetch={
                  item.isOpenNewTab && item.isOpenNewTab === "1"
                    ? false
                    : internalUrl(item.url || item.link).internal
                }
                passHref
              >
                <a
                  key={item.id}
                  onClick={() => handleClick(item, index)}
                  target={
                    item.isOpenNewTab && item.isOpenNewTab === "1"
                      ? "_blank"
                      : "_self"
                  }
                  style={{
                    backgroundImage: `url(${item.image})`,
                    width: isMobile
                      ? props.mobile_width
                        ? props.mobile_width
                        : props.width
                      : props.width,
                    height: isMobile
                      ? props.mobile_height
                        ? props.mobile_height
                        : props.height
                      : props.height,
                  }}
                  className={styles["image-container"]}
                  id={`${item.id}-smallCards`}
                  data-cms-title={item.analyticTitle}
                >
                  <CustomContainer
                    className={styles["image-container__content"]}
                  >
                    {item?.icon && (
                      <CustomContainer
                        className={`${styles["image-container__logo"]} ${
                          styles[
                            props.data.cardType === "Brand" ? "logo" : "icon"
                          ]
                        }`}
                      >
                        <img
                          src={item.icon}
                          className={styles["image"]}
                          id={`${item?.name}-brand-icon`}
                        />
                      </CustomContainer>
                    )}
                    {item?.name && (
                      <CustomContainer
                        className={styles["image-container__category-name"]}
                      >
                        {item.name}
                      </CustomContainer>
                    )}
                    {item?.title && (
                      <CustomContainer
                        className={styles["image-container__title"]}
                        id={`${item.title}-banner`}
                      >
                        {item.title}
                      </CustomContainer>
                    )}
                    {item?.description && (
                      <CustomContainer
                        className={styles["image-container__description"]}
                        dangerouslySetInnerHTML={createMarkup(item.description)}
                        id={`${item.title}-desc-banner`}
                      />
                    )}
                  </CustomContainer>
                </a>
              </Link>
            ))}
          </OwlCarousel>
        </CustomContainer>
      </CustomContainer>
      {!props.hideCarousel && !sizeCheck && (
        <CustomContainer className="custom-owl--nav">
          <CarouselButton
            prev
            variant="small-carousel"
            handleClick={prev}
            className={previousNavClass}
            id="SmallCardCarousel_arrowBackBtn"
          />
          <CarouselButton
            next
            handleClick={next}
            variant="small-carousel"
            className={nextNavClass}
            id="SmallSCardCarousel_arrowNextBtn"
          />
        </CustomContainer>
      )}
    </CustomContainer>
  );
};

export default SmallCardsCarousel;
